// 20.2.2.20 Math.log1p(x)
var $export = require('./$.export');

$export($export.S, 'Math', {log1p: require('./$.math-log1p')});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.math.log1p.js
// module id = 112
// module chunks = 0